/* eslint-disable camelcase */

import { fetch } from '../utils/request';

const getUrl = (path) => `${process.env.MONO_API}${path}`;

export default {
  getExperience(partner, id) {
    return fetch(getUrl(`/partners/${partner}/experiences/${id}`));
  },
};
